import React, { useEffect, useState } from "react";
import s from "../Stock.module.css";

//assets
import gamesService from "../../../../api/games/GamesService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material Ui
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import useTranslationException from "../../../../helpers/exceptions";

const onlyPreprinted = (g) => {
  return (g) => g?.modality?.mode?.id === 1;
};

const onlyInstantaneous = (g) => {
  return (g) => g?.modality?.mode?.id === 2;
};

const preprintedDateTypes = [
  /* 0 - Ninguno */ null,
  /* 1 - Fecha de sorteo */ "raffleDate",
  /* 2 - Fecha de carga */ "createDate",
];

const instantaneousDateTypes = [
  /* 0 - Ninguno */ null,
  /* 1 - Fecha de carga */ "createDate",
];

const resetFilters = (prev) => ({
  ...prev,
  dateTypeName: null,
  dateFrom: null,
  dateTo: null,
});

const FiltersStockPreprinted = ({
  dateType,
  setDateType,
  filters,
  setFilters,
  t,
}) => {
  const { language } = useSelector((state) => state.local);

  return (
    <>
      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
        <FormControl sx={{ width: "90%" }}>
          <InputLabel
            id={"select-label"}
          >{`${t("type")} de ${t("date")}`}</InputLabel>
          <Select
            labelId="select-label"
            label={`${t("type")} de ${t("date")}`}
            value={dateType}
            onChange={(e) => {
              if (e.target.value === 0) {
                setDateType(e.target.value);
                setFilters(resetFilters);
              } else {
                setDateType(e.target.value);
                setFilters((prev) => ({
                  ...prev,
                  dateTypeName: preprintedDateTypes[e.target.value],
                }));
              }
            }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            <MenuItem value={1}>{t("drawDate")}</MenuItem>
            <MenuItem value={2}>{t("uploadDate")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {!dateType ? null : (
        <>
          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={language}
            >
              <DatePicker
                label={!!filters?.dateFrom ? `${t("date")} X` : t("date")}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, dateFrom: e }))
                }
                inputFormat="DD/MM/YYYY"
                clearable
                value={filters.dateFrom || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{ width: "90%" }}
                    InputLabelProps={{
                      onClick: () =>
                        setFilters((prev) => ({ ...prev, dateFrom: null })),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          {/*
                    <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={!!filters?.dateTo ? `${t('to')} X` : t('to')}
                                onChange={(e) => setFilters(prev => ({...prev, dateTo: e}))}
                                inputFormat="DD/MM/YYYY"
                                clearable
                                value={filters.dateTo || null}
                                renderInput={(params) => <TextField {...params} variant="outlined" sx={{width: '90%'}} InputLabelProps={{onClick: () => setFilters(prev => ({...prev, dateTo: null}))}}/>}
                            />
                        </LocalizationProvider>
                    </Grid>
                    */}
        </>
      )}
    </>
  );
};

const FiltersStockInstantaneous = ({
  dateType,
  setDateType,
  filters,
  setFilters,
  t,
}) => {
  const { language } = useSelector((state) => state.local);

  return (
    <>
      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
        <FormControl sx={{ width: "100%" }}>
          <InputLabel
            id={"select-label"}
          >{`${t("type")} de ${t("date")}`}</InputLabel>
          <Select
            labelId="select-label"
            label={`${t("type")} de ${t("date")}`}
            value={dateType}
            onChange={(e) => {
              if (e.target.value === 0) {
                setDateType(e.target.value);
                setFilters(resetFilters);
              } else {
                setDateType(e.target.value);
                setFilters((prev) => ({
                  ...prev,
                  dateTypeName: instantaneousDateTypes[e.target.value],
                }));
              }
            }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            <MenuItem value={1}>{t("uploadDate")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {!dateType ? null : (
        <>
          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={language}
            >
              <DatePicker
                label={!!filters?.dateFrom ? `${t("date")} X` : t("date")}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, dateFrom: e }))
                }
                inputFormat="DD/MM/YYYY"
                clearable
                value={filters.dateFrom || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{ width: "90%" }}
                    InputLabelProps={{
                      onClick: () =>
                        setFilters((prev) => ({ ...prev, dateFrom: null })),
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          {/*
                    <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={!!filters?.dateTo ? `${t('to')} X` : t('to')}
                                onChange={(e) => setFilters(prev => ({...prev, dateTo: e}))}
                                inputFormat="DD/MM/YYYY"
                                clearable
                                value={filters.dateTo || null}
                                renderInput={(params) => <TextField {...params} variant="outlined" sx={{width: '90%'}} InputLabelProps={{onClick: () => setFilters(prev => ({...prev, dateTo: null}))}}/>}
                            />
                        </LocalizationProvider>
                    </Grid>
                    */}
        </>
      )}
    </>
  );
};

const FiltersStock = ({
  searching,
  handleCleanFilters,
  handleSearch,
  dateType,
  setDateType,
  filters,
  setFilters,
  setLoadingFilters,
  games,
  setGames,
  handleCleanTable,
}) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  useEffect(() => {
    if (!games.length) {
      setLoadingFilters(true);
      gamesService
        .getAllGames()
        .then((res) => {
          setGames(res.content);
          setLoadingFilters(false);
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoadingFilters(false);
        });
    }
  }, []);

  return (
    <Grid item container xs={11} className={s.filters}>
      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
        <FormControl fullWidth>
          <InputLabel id="label-select">{`${t("type")} de ${t("game")}`}</InputLabel>
          <Select
            onChange={(e) => {
              handleCleanTable();
              setFilters((prev) => ({
                ...prev,
                type: e.target.value,
                gameId: null,
              }));
            }}
            value={filters.type}
            labelId="label-select"
            label={`${t("type")} de ${t("game")}`}
            sx={{ width: "90%" }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            <MenuItem value={1}>{t("preprinted")}</MenuItem>
            <MenuItem value={2}>{t("instant")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {filters.type !== 0 && (
        <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
          <FormControl fullWidth>
            <InputLabel id="label-select-game">{t("game")}</InputLabel>
            <Select
              displayEmpty
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  gameId: e.target.value !== 0 ? e.target.value : null,
                }))
              }
              value={filters.gameId === null ? 0 : filters.gameId}
              disabled={filters.type === 0}
              labelId="label-select-game"
              label={t("game")}
              sx={{ width: "90%" }}
            >
              <MenuItem key={0} value={0}>
                {t("all")}
              </MenuItem>
              {games
                .filter((item) => item.modality.mode.id === filters.type)
                .map((item, i) => {
                  return (
                    <MenuItem key={i} value={item.modality?.game?.id}>
                      {item.modality?.game?.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Grid>
      )}
      {filters?.type === 1 && (
        <FiltersStockPreprinted
          dateType={dateType}
          setDateType={setDateType}
          filters={filters}
          setFilters={setFilters}
          setLoadingFilters={setLoadingFilters}
          games={games}
          setGames={setGames}
          t={t}
          organization={organization}
        />
      )}
      {filters?.type === 2 && (
        <FiltersStockInstantaneous
          dateType={dateType}
          setDateType={setDateType}
          filters={filters}
          setFilters={setFilters}
          setLoadingFilters={setLoadingFilters}
          games={games}
          setGames={setGames}
          t={t}
          organization={organization}
        />
      )}

      <Grid item xs={12} sx={{ mb: 1 }}>
        <Button
          disabled={!filters.type}
          onClick={handleSearch}
          variant="contained"
        >
          {t("consult")}
        </Button>
        {searching ? (
          <Button
            onClick={handleCleanFilters}
            variant="contained"
            sx={{ ml: 1 }}
          >
            {t("clearFilters")}
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default FiltersStock;
